import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';

export function fetchExerciseDropDown(response) {
  return {
    type: types.EXERCISE_DROPDOWN,
    response,
  };
}
export function fetchSubjectDropDown(response) {
  return {
    type: types.SUBJECT_DROPDOWN,
    response,
  };
}
export function fetchWorkBookQuestionData(response) {
  return {
    type: types.WORKBOOK_DETAILS,
    response,
  };
}
export function enableLoader() {
  return {
    type: types.LOGIN_ENABLE_LOADER,
  };
}

export function disableLoader() {
  return {
    type: types.LOGIN_DISABLE_LOADER,
  };
}

export const fetchDropDownData = async (jwtToken, dispatch) => {
  const body = {};
  const url = 'api/studentworkbooktype';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }
      dispatch(fetchExerciseDropDown(data));
    });
};

export const fetchSubjectData = async (WorkBookTypeID, jwtToken, dispatch) => {
  dispatch(enableLoader());
  const body = {
    WorkBookTypeID: WorkBookTypeID,
  };
  const url = 'api/studentworkbooksubject';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        dispatch(disableLoader());
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        dispatch(disableLoader());
        return dispatch(logOut());
      }
      dispatch(disableLoader());
      dispatch(fetchSubjectDropDown(data));
    });
};
export const fetchWorkBookQuestion = async (workBookID, jwtToken, dispatch) => {
  const body = {
    workBookID: workBookID,
  };
  const url = 'api/WorkBookQuestion';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }
      dispatch(fetchWorkBookQuestionData(data));
    });
};
